module.exports = __webpack_public_path__ + "media/images/emblems/Chatonnaye-coat_of_arms-a0c761f0011c6cd3d85ff71c80b65256.svg";